import Model, { attr } from '@ember-data/model';
import { objectAttr } from 'eflex/decorators';

export default class ScheduleProcessDatum extends Model {
  @attr('number') scheduleTarget;

  @objectAttr station;
  @objectAttr model;
}
